import axios from "axios";
import storeOne from "../store/index";
import { Loading, Message } from "element-ui";
import router from "@/router";

// 设置基地址
const request = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
});
let loadingInstance = null;
const AUTH_EXPIRED_MESSAGE = "登录信息失效，请重新登录";

function handleAuthExpired() {
  const hadToken = Boolean(storeOne.state.tokenObj.token);
  storeOne.commit("logout");
  if (router.currentRoute.path !== "/login") {
    if (hadToken) Message.error(AUTH_EXPIRED_MESSAGE);
    router.replace("/login").catch(() => {});
  }
  const error = new Error(AUTH_EXPIRED_MESSAGE);
  error.isAuthExpired = true;
  return Promise.reject(error);
}

function isLoginRequest(config) {
  return config?.url?.split("?")[0] === "/admin/login";
}
console.log('baseURL 实际值：', request.defaults.baseURL);
// 请求拦截器
request.interceptors.request.use(
  function (config) {
    // 避免重复创建loading
    if (!loadingInstance) {
      loadingInstance = Loading.service({
        text: "请求中，请稍候...",
      });
    }
    // 给URL添加时间戳防缓存
    const index = config.url.indexOf("?");
    if (index === -1) {
      config.url = config.url + "?time=" + new Date().getTime();
    } else {
      config.url = config.url + "&time=" + new Date().getTime();
    }
    config.headers.token = storeOne.state.tokenObj.token;
    return config;
  },
  function (error) {
    // 请求失败时关闭loading（避免loading一直显示）
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null; // 重置
    }
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use((response) => {
  // 关闭loading并重置
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
  const res = response?.data;

  if (res.code == 401) {
    if (isLoginRequest(response.config)) {
      Message.error(res.msg || "登录失败");
      return Promise.reject(new Error(res.msg || "登录失败"));
    }
    return handleAuthExpired();
  } else if (res.code !== 200) {
    Message({
      message: res.msg || "访问出错",
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(res.msg || "访问出错");
  } else {
    return res;
  }
}, (error) => {
  // 关闭loading并重置
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }

  // 处理无响应的情况（比如网络错误，error.response 为 undefined）
  if (!error.response) {
    Message.error("网络异常，请检查网络连接");
    return Promise.reject(error);
  }

  const errorData = error.response.data;
  if (error.response.status === 401) {
    if (isLoginRequest(error.config)) {
      Message.error(errorData?.msg || "登录失败");
      return Promise.reject(error);
    }
    return handleAuthExpired();
  } else {
    Message.error(errorData?.msg || "请求失败");
  }
  return Promise.reject(error);
});

export default request;
